import { CalendarCheck } from "lucide-react";
import Reveal from "./Reveal";
import { SITE } from "../config/site";

export default function FlexibleScheduling() {
  return (
    <section id="scheduling" data-testid="scheduling-section" className="bg-mist py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <Reveal className="flex flex-col items-start gap-8 rounded-3xl border border-ink/10 bg-white p-10 shadow-[0_24px_60px_-32px_rgba(14,53,39,0.25)] md:flex-row md:items-center lg:p-14">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-seafoam/15">
            <CalendarCheck className="h-8 w-8 text-seafoam" strokeWidth={1.8} />
          </div>
          <div className="flex-1">
            <p className="eyebrow">Flexible Scheduling</p>
            <h2 className="mt-3 font-serif text-3xl tracking-tight text-ink sm:text-4xl">
              Flexible Scheduling <span className="italic text-ocean">Available</span>
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-slateblue">
              We work around your schedule and cleaning needs — whether it's a one-time clean,
              recurring visits, or a rental turnover. Contact us to discuss a convenient time
              for your cleaning service.
            </p>
          </div>
          <a
            href="#quote"
            data-testid="scheduling-quote-button"
            className="shrink-0 rounded-full bg-ocean px-8 py-4 text-sm font-bold uppercase tracking-widest text-salt transition-[background-color,transform] duration-300 hover:bg-seafoam hover:scale-[1.03]"
          >
            Get a Free Quote
          </a>
        </Reveal>
      </div>
    </section>
  );
}
